<template>
	<div>
		<!-- MOCK: for Apeiron -->
		<template v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)">
			<apeiron-users-update />
		</template>

		<!-- default users detail -->
		<template v-else>
			<default-users-update />
		</template>
	</div>
</template>

<script>
import DefaultUsersUpdate from "../components/DefaultUsersUpdate"
import ApeironUsersUpdate from "../components/mockedApeiron/ApeironUsersUpdate"

export default {
	components: { DefaultUsersUpdate, ApeironUsersUpdate }
}
</script>
